import {fetchOverviewApi} from '../../services/nmbs-users-api';
import {fetchMetaDataApi, exportToExcelFileAuditDetailsApi} from '../../services/common-api';

export const fetchOverview = () => {
    return fetchOverviewApi();
}

export const fetchMetaData = () => {
    return fetchMetaDataApi(4);
}

export const exportToExcelAuditDetails = (overviewDetailRequestModel) => {
    return exportToExcelFileAuditDetailsApi(overviewDetailRequestModel);
}